import {ChangeDetectorRef, Component, Inject, Input, OnDestroy, OnInit} from '@angular/core';
import {Chat, IMessengerConnector} from '../../../../types/all.type';
import {ModalService} from '../../../../services/modal.service';
import {Subject, Subscription, takeUntil} from 'rxjs';
import {AllService} from '../../../../services/all.service';
import {InterfaceService} from '../../../../services/interface.service';


@Component({
  selector: 'app-messages-profile',
  templateUrl: './messages-profile.component.html',
  styleUrls: ['./messages-profile.component.scss']
})
export class MessagesProfileComponent implements OnInit, OnDestroy {
  private destroy$: Subject<void> = new Subject();
  @Input() chat: Chat;
  @Input() Service: IMessengerConnector;

  constructor(
    private allService: AllService,
    private cd: ChangeDetectorRef,
    public modalService: ModalService,
    public interfaceService: InterfaceService
  ) {
  }

  ngOnInit(): void {
    this.interfaceService.openChat$.pipe(takeUntil(this.destroy$)).subscribe((event) => {
      this.cd.detectChanges();
    });
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
